export const deletionTitle = "Delete Invitation";

export const deletionDescription =
  "You can invite up to 1 friend to participate in Pollinator with you, for free. Manage your existing invite below.";
